import { render } from "./SkeletonBox.vue?vue&type=template&id=3887108a"
import script from "./SkeletonBox.vue?vue&type=script&lang=js"
export * from "./SkeletonBox.vue?vue&type=script&lang=js"

import "./SkeletonBox.vue?vue&type=style&index=0&id=3887108a&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__